export const DIV_TAG_NAME = "DIV";
export const EMPTY_STRING = "";
export const COMPOSITE_FIELD_VALUE_SEP = " ";
export const allowlistedFormElements = [
    "KAT-INPUT",
    "KAT-DATE-PICKER",
    "KAT-DROPDOWN",
    "KAT-TEXTAREA"
]

export const FIELD_CLASS_NAME = "event-input-field";
export const FIELD_ID_PREFIX: string = "event-input";
export const SEVERITY_ID: string = FIELD_ID_PREFIX + "-severity";
export const SUMMARY_ID: string = FIELD_ID_PREFIX + "-summary";
export const DESCRIPTION_ID: string = FIELD_ID_PREFIX + "-description";
export const START_ID: string = FIELD_ID_PREFIX + "-start";
export const END_ID: string = FIELD_ID_PREFIX + "-end";
export const DATE_SUFFIX: string = "-date";
export const TIME_SUFFIX: string = "-time";